let toastHandler: ((text: string) => void) | null = null;

export const subscribeToast = (handler: (text: string) => void) => {
  toastHandler = handler;

  return () => {
    toastHandler = null;
  };
};

export const openToast = (text: string) => {
  toastHandler?.(text);
};
